import { Redirect, Route } from 'react-router-dom';
import PermissionsGate from '../../app/api/PermissionsGate';
import * as KeyNames from '../api/KeyNames';
import PrivateRoutesConfig from './PrivateRoutesConfig';
import React from 'react';

// export function PrivateRoutes() {
//   return (
//     <>
//       {
//         PrivateRoutesConfig.map((entry) => {
//           const { menutitle, routes, redirects, ...rest } = entry;
//           return (
//             <div key={JSON.stringify(entry)}>
//               {
//                 routes && routes.map((route) =>
//                   route.subRoutes ? route.subRoutes.map(
//                     (subRoute) =>
//                       (subRoute.path !== '') && (
//                         <PermissionsGate key={JSON.stringify(subRoute.scopes) + menutitle} RenderError={() => <></>} scopes={subRoute.scopes}>
//                           {subRoute.Component ?
//                             <Route
//                               // key={JSON.stringify(subRoute)}
//                               path={subRoute.path}
//                               component={() => subRoute.Component({ title: subRoute.title })}
//                               {...subRoute.rest}
//                             /> :
//                             <Route
//                               // key={JSON.stringify(subRoute)}
//                               path={subRoute.path}
//                               component={() => { localStorage.setItem(KeyNames.PathName, '/dashboard'); window.location.href = subRoute.external; return null; }}
//                               {...route.rest}
//                             />
//                           }
//                         </PermissionsGate>
//                       )
//                   ) :
//                     (route.path !== '' && route.scopes.length > 0) && (
//                       <PermissionsGate key={JSON.stringify(route.scopes) + route.path} RenderError={() => <></>} scopes={route.scopes}>
//                         {route.Component ?
//                           <Route
//                             // key={JSON.stringify(route)}
//                             path={route.path}
//                             component={() => route.Component({ title: route.title })}
//                             {...route.rest}
//                           /> :
//                           <Route
//                             // key={JSON.stringify(route)}
//                             path={route.path}
//                             component={() => { localStorage.setItem(KeyNames.PathName, '/dashboard'); window.location.href = route.external; return null; }}
//                             {...route.rest}
//                           />
//                         }
//                       </PermissionsGate>
//                     )

//                 )
//               }
//               {
//                 redirects && redirects.map(
//                   (redirect) =>
//                     <PermissionsGate key={redirect.from + redirect.to + redirect.scope} RenderError={() => <></>} scopes={redirect.scopes}>
//                       <Redirect
//                         // key={redirect.from + redirect.to}
//                         to={redirect.to}
//                         {...(redirect.exact && "exact")}
//                         {...redirect.rest}
//                       />
//                     </PermissionsGate>
//                 )
//               }
//             </div>
//           )
//         }
//         )
//       }
//     </>
//   );
// }

export function PrivateRoutes() {
  return (
    <>
      {PrivateRoutesConfig.map((entry) => {
        const { menutitle, routes, redirects, ...rest } = entry;
        return (
          <React.Fragment key={JSON.stringify(entry)}>
            {routes && routes.map((route) =>
              route.subRoutes ? route.subRoutes.map((subRoute) =>
                subRoute.path !== '' && (
                  <PermissionsGate key={JSON.stringify(subRoute.scopes) + menutitle} RenderError={() => <></>} scopes={subRoute.scopes}>
                    {subRoute.Component ?
                      <Route
                        path={subRoute.path}
                        component={() => subRoute.Component({ title: subRoute.title })}
                        {...subRoute.rest}
                      /> :
                      <Route
                        path={subRoute.path}
                        component={() => { localStorage.setItem(KeyNames.PathName, '/dashboard'); window.location.href = subRoute.external; return null; }}
                        {...route.rest}
                      />
                    }
                  </PermissionsGate>
                )
              ) :
                (route.path !== '' && route.scopes.length > 0) && (
                  <PermissionsGate key={JSON.stringify(route.scopes) + route.path} RenderError={() => <></>} scopes={route.scopes}>
                    {route.Component ?
                      <Route
                        path={route.path}
                        component={() => route.Component({ title: route.title })}
                        {...route.rest}
                      /> :
                      <Route
                        path={route.path}
                        component={() => { localStorage.setItem(KeyNames.PathName, '/dashboard'); window.location.href = route.external; return null; }}
                        {...route.rest}
                      />
                    }
                  </PermissionsGate>
                )
            )}
            {redirects && redirects.map((redirect) =>
              <PermissionsGate key={redirect.from + redirect.to + redirect.scope} RenderError={() => <></>} scopes={redirect.scopes}>
                <Redirect
                  to={redirect.to}
                  {...(redirect.exact && "exact")}
                  {...redirect.rest}
                />
              </PermissionsGate>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}


